import { UploadFile } from 'components/Dropzone';

export async function getFileBlob(file: UploadFile): Promise<File> {
  const { blobURL, name, type } = file;
  const blob = await fetch(blobURL).then((res) => res.blob());
  return new File([blob], name, {
    type: type,
  });
}
